<script setup lang="ts">
import { computed } from 'vue';
import type { Area, Category } from '@ilteducation/content-ref-data-types';
import AreaListButton from '@/components/AreaListButton.vue';
import useAreasWithVideos from '@/composables/use-areas-with-videos';

const props = defineProps<{
  subject: Category;
}>();

const emit = defineEmits<{
  (e: 'area-clicked', slug: string): void;
}>();

const { areasWithVideos, isLoading } = useAreasWithVideos();
const existingAreas = computed(() =>
  areasWithVideos.value.filter((area) => area.categoryId === props.subject.id && area.active),
);

const onAreaClick = (area: Area) => {
  emit('area-clicked', area.slug);
};
</script>

<template>
  <v-row justify="center">
    <template v-if="!isLoading">
      <v-col v-for="(area, index) in existingAreas" :key="index" cols="12" sm="6" md="4" lg="3">
        <AreaListButton :area="area" :subject="subject" @films-clicked="onAreaClick" />
      </v-col>
    </template>
    <template v-else>
      <v-col v-for="n in 4" :key="`areaskeleton-${n}`" cols="12" sm="6" md="4" lg="3">
        <v-skeleton-loader class="overflow-hidden" :max-height="70" type="image"></v-skeleton-loader>
      </v-col>
    </template>
  </v-row>
</template>
